@if (!hideShell) {
  <ez-system-banner />
  <ez-header />
  <mat-sidenav-container class="main-container"
                         [hasBackdrop]="isMobile"
                         (backdropClick)="closeWorkspace()">
    <mat-sidenav-content>
      <mat-sidenav-container autosize
                             class="full-width"
                             [hasBackdrop]="false">
        <mat-sidenav #mainSideNav
                     mode="over"
                     [ezResizableSidePanel]="mainSideNav"
                     [ezResizableSidePanelEnabled]="mainSidePanelConfig().resizable!"
                     [sidePanelDragHandle]="mainSidePanelHandle"
                     [sidePanelDefaultWidth]="mainSidePanelConfig().initialWidth"
                     [style.max-width]="mainSidePanelMaxWidth() "
                     [style.min-width]="mainSidePanelMinWidth()"
                     [opened]="isMainSidePanelOpen()"
                     position="end"
                     (keydown.escape)="closeSidePanel()"
                     (sidePanelSettingsChanged)="mainSidePanelSettingsChanged($event)">
          <ez-resizable-side-panel-drag-handle #mainSidePanelHandle />
          <ng-container #mainSideNavContainer />
        </mat-sidenav>
        <mat-sidenav-content>
          <ng-container *ngTemplateOutlet="mainContent" />
        </mat-sidenav-content>
      </mat-sidenav-container>
    </mat-sidenav-content>
    <mat-sidenav [mode]="isMobile ? 'over' : 'side'"
                 position="end"
                 [opened]="workspaceVisible() && !!user"
                 disableClose="true">
      @if (workspaceVisible()) {
        <ez-workspace />
      }
    </mat-sidenav>
  </mat-sidenav-container>

  <mat-sidenav-container [class.extended-sidebar]="showExtendedWorkspace()">
    <mat-sidenav [opened]="showExtendedWorkspace()"
                 position="end"
                 mode="side">
      <ng-template #extendedWorkspaceTemplate />
    </mat-sidenav>
  </mat-sidenav-container>
  <ez-footer />
} @else {
  <ng-container *ngTemplateOutlet="mainRouting" />
}

@if (appLoadingService.loading) {
  <div class="blocking-spinner-container">
    <mat-spinner />
  </div>
}

<ng-template #mainContent>
  <ez-nav-menu id="Navbar" />
  <ez-eva-sidebar />

  <div class="router-loading-bar">
    @if (routerLoading && !firstRoutedPage) {
      <mat-progress-bar />
    }
  </div>
  @if (routerLoading && firstRoutedPage || !user) {
    <mat-spinner class="full-page-spinner" />
  }
  <div class="root-router-container">
    <ez-banner [style.marginLeft]="{ '40px': mobileMenuVisible }" />
    <ng-container *ngTemplateOutlet="mainRouting" />
  </div>
</ng-template>

<ng-template #mainRouting>
  @if (user) {
    <router-outlet class="root-router" />
  }
</ng-template>